const Error404 = () => {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "14rem",
        backgroundColor: "white",
        padding: "6rem",
      }}
    >
      <h1>Error 404</h1>
      <p>Nada por aqui, intenta con otra ruta</p>
    </div>
  );
};

export default Error404;
